import { useState } from "react";
import { Sparkles, Loader2, Plus } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { ugcAPI } from "../../lib/api";

const MAX = 120;

export function MustShowField({ value, onChange, productName, productDescription, productImage }) {
  const [ideas, setIdeas] = useState([]);
  const [loading, setLoading] = useState(false);

  const suggest = async () => {
    if (!productName?.trim() && !productImage) {
      toast.info("Add the product name or a photo first");
      return;
    }
    setLoading(true);
    try {
      setIdeas(await ugcAPI.getMustShowIdeas({ productName, productDescription, productImage }));
    } catch {
      toast.error("Couldn't get ideas right now");
    } finally {
      setLoading(false);
    }
  };

  const addIdea = (idea) => {
    const next = value.trim() ? `${value.trim()}, ${idea}` : idea;
    if (next.length > MAX) {
      toast.info("That would go over 120 characters");
      return;
    }
    onChange(next);
    setIdeas((list) => list.filter((i) => i !== idea));
  };

  return (
    <div data-testid="must-show-field">
      <div className="flex items-center justify-between mb-1">
        <Label className="text-white/70 text-xs">Must show (optional)</Label>
        <div className="flex items-center gap-3">
          <button type="button" data-testid="must-show-suggest-btn" onClick={suggest} disabled={loading}
            className="flex items-center gap-1 text-[11px] text-cyan-400 hover:text-cyan-300 transition-colors disabled:opacity-50">
            {loading ? <Loader2 className="w-3 h-3 animate-spin" /> : <Sparkles className="w-3 h-3" />} Suggest ideas
          </button>
          <span data-testid="must-show-count" className="text-white/40 text-[10px]">{value.length}/{MAX}</span>
        </div>
      </div>
      <Input
        data-testid="must-show-input"
        value={value}
        maxLength={MAX}
        onChange={(e) => onChange(e.target.value)}
        placeholder='e.g. "water bottle on top", "logo facing the camera"'
        className="bg-white/5 border-white/10 text-white"
      />
      {ideas.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2" data-testid="must-show-ideas">
          {ideas.map((idea, i) => (
            <button key={idea} type="button" data-testid={`must-show-idea-${i}`} onClick={() => addIdea(idea)}
              className="flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] bg-white/5 border border-white/15 text-white/80 hover:border-cyan-400 hover:text-cyan-300 transition-colors">
              <Plus className="w-3 h-3" /> {idea}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
